import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import ChatIcon from '@material-ui/icons/Chat';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    //height: '50%',
    //maxWidth: '700px',
    //margin: '24px 20px 24px 20px',
    [theme.breakpoints.only('xs')]: {
      width: '320px',
    },
  },
  title: {
    fontWeight: 600,
    fontSize: 24,
    color: '#333333',
    maxWidth: '630px',
    margin: '24px 20px 0px 20px',
  },
  details: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#333333',
  },
  iconFormat: {
    color: '#999999',
    paddingRight: '2px',
  },
  link: {
    color: '#0055A5',
    alignItems: 'left',
    fontSize: '13px !important',
    fontWeight: 'bold',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  noticeDetails: {
    whiteSpace: 'pre-line',
    fontWeight: 550,
  },
  noticePage: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginLeft: '13%',
      marginRight: '8%',
      marginTop: '2%',
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: '5%',
      marginRight: '3%',
    },
  },
}));

const NoticePage = () => {
  const classes = useStyles();
  //(documentUploadContext);
  return (
    <div className={classes.noticePage}>
      <label className={classes.title}>Notice</label>
      <Card className={classes.root}>
        <CardContent>
          <Typography className={classes.noticeDetails}>
            {
              'We regret that you will not be able to continue your transaction at the moment. We are currently doing system maintenance as part of our service improvement. \r\n  \r\n '
            }
            {'Kindly try again after a few minutes. \r\n  \r\n  \r\n '}
            {'Thank you for your usual understanding and patronage. \r\n'}
            {'Your PSBank Onboarding Team. \r\n \r\n  \r\n'}
            {' For urgent concerns, you may contact us at: \r\n'}
          </Typography>
          <Grid container direction='row' justify='space-around'>
            <Grid item xs={12} sm={12} md={6} lg={5}>
              <Typography className={classes.link}>
                <EmailIcon className={classes.iconFormat} />
                <a
                  href='mailto:customerexperience@psbank.com.ph'
                  className={classes.link}
                >
                  customerexperience@psbank.com.ph
                </a>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <Typography className={classes.link}>
                <PhoneIcon className={classes.iconFormat} />
                (632) 8845-8888
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={4}>
              <Typography className={classes.link}>
                <ChatIcon className={classes.iconFormat} />
                <a
                  href={`${process.env.REACT_APP_URL}contact-us/`}
                  className={classes.link}
                >
                  Live Chat
                </a>
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};
export default NoticePage;
